import React, { useState } from "react";
import "../styles/login.css";
import "../styles/all.css";
import { useNavigate } from "react-router-dom";
import Form from "react-bootstrap/Form";
import { Button } from "react-bootstrap";
import { Formik, ErrorMessage } from "formik";
import * as Yup from "yup";
import axios from "axios";
import Alert from "react-bootstrap/Alert";
import InputGroup from "react-bootstrap/InputGroup";
import useDocumentTitle from "../services/documentTitle";

const initialValues = {
  firstName: "",
  lastName: "",
  email: "",
  password: "",
  passwordConfirmation: "",
  terms: false,
};

const SignupSchema = Yup.object().shape({
  firstName: Yup.string()
    .min(2, "trop petit!")
    .max(50, "trop long!")
    .required("Ce champ est obligatoire"),
  lastName: Yup.string()
    .min(2, "trop petit!")
    .max(50, "trop long!")
    .required("Ce champ est obligatoire"),
  email: Yup.string()
    .email("email invalide")
    .required("Ce champ est obligatoire"),
  password: Yup.string()
    .required("Mot de passe est obligatoire")
    .min(8, "Mot de passe doit être plus grand que 8 caractères")
    .max(50, "Mot de passe doit être plus petit que 50 caractères"),
  passwordConfirmation: Yup.string()
    .oneOf([Yup.ref("password")], "Le mot de passe doit être identifique!")
    .required("Mot de passe est obligatoire"),
  terms: Yup.bool().oneOf([true], "Accepter les conditions est obligatoire"),
});

const SignUp = () => {
  useDocumentTitle("Inscription");
  const [msg, setMsg] = useState("");
  const [msgClass, setMsgClass] = useState("");

  const [passwordType1, setPasswordType1] = useState("password");
  const [passwordType2, setPasswordType2] = useState("password");

  const navigateLogin = useNavigate();
  const goToLogin = () => {
    navigateLogin("/login", { replace: true });
  };

  const onSubmit = (values, { setSubmitting, resetForm }) => {
    axios({
      method: "POST",
      url: `${process.env.REACT_APP_API_URL}/auth/signup`,
      data: values,
      withCredentials: true,
    })
      .then((response) => {
        setSubmitting(false);
        resetForm();
        setMsg(response.data.message);
        setMsgClass("success");
      })
      .catch((error) => {
        setSubmitting(false);
        resetForm();
        setMsg(error.response.data.message);
        setMsgClass("danger");
        console.log(error);
      });
  };

  return (
    <div className="bgcolorffffff p-lg-5">
      <h1 className="text-center p-5 m-5">Inscrivez-vous</h1>
      <div className="form-wrapper">
        <Formik
          initialValues={initialValues}
          validationSchema={SignupSchema}
          onSubmit={onSubmit}
        >
          {({
            handleSubmit,
            handleChange,
            handleBlur,
            values,
            touched,
            errors,
          }) => (
            <Form className="" onSubmit={handleSubmit}>
              <div className="d-flex justify-content-between">
                <Form.Group className="my-3">
                  <Form.Label className="font-size-1_2">Prénom</Form.Label>
                  <Form.Control
                    autoComplete="given-name"
                    required
                    name="firstName"
                    type="text"
                    value={values.firstName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    placeholder="Entrez votre Prénom."
                    isValid={touched.firstName && !errors.firstName}
                    isInvalid={!!errors.firstName}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.firstName}
                  </Form.Control.Feedback>
                </Form.Group>
                <Form.Group className="my-3">
                  <Form.Label className="font-size-1_2">Nom</Form.Label>
                  <Form.Control
                    autoComplete="family-name"
                    required
                    name="lastName"
                    type="text"
                    value={values.lastName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    placeholder="Entrez votre Nom."
                    isValid={touched.lastName && !errors.lastName}
                    isInvalid={!!errors.lastName}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.lastName}
                  </Form.Control.Feedback>
                </Form.Group>
              </div>
              <Form.Group className="my-3" controlId="formBasicEmail">
                <Form.Label className="font-size-1_2">
                  Adresse e-mail
                </Form.Label>
                <Form.Control
                  autoComplete="email"
                  required
                  name="email"
                  type="email"
                  value={values.email}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  placeholder="Entrez votre adresse e-mail."
                  isValid={touched.email && !errors.email}
                  isInvalid={!!errors.email}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.email}
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="mt-4" controlId="formBasicPassword">
                <Form.Label className="font-size-1_2">Mot de passe</Form.Label>
                <InputGroup>
                  <Form.Control
                    required
                    name="password"
                    type={passwordType1}
                    value={values.password}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    placeholder="Entrez votre mot de passe."
                    isValid={touched.password && !errors.password}
                    isInvalid={!!errors.password}
                  />
                  <InputGroup.Text
                    onClick={() =>
                      passwordType1 === "password"
                        ? setPasswordType1("text")
                        : setPasswordType1("password")
                    }
                    style={{ cursor: "pointer" }}
                  >
                    {passwordType1 === "password" ? (
                      <i className="fa-regular fa-eye-slash"></i>
                    ) : (
                      <i className="fa-regular fa-eye"></i>
                    )}
                  </InputGroup.Text>
                </InputGroup>
                <div>
                  <Form.Text className="text-muted font-size-1_2">
                    Nous ne partagerons jamais votre mot de passe avec qui que
                    ce soit d'autre.
                  </Form.Text>
                </div>
                <ErrorMessage
                  component="span"
                  name="password"
                  className="text-danger"
                />
              </Form.Group>
              <Form.Group
                className="my-3"
                controlId="formBasicPasswordConfirmation"
              >
                <Form.Label className="font-size-1_2">
                  Veuillez confirmer votre mot de passe
                </Form.Label>
                <InputGroup>
                  <Form.Control
                    required
                    name="passwordConfirmation"
                    type={passwordType2}
                    value={values.passwordConfirmation}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    placeholder="Entrez votre mot de passe."
                    isValid={
                      touched.passwordConfirmation &&
                      !errors.passwordConfirmation
                    }
                    isInvalid={!!errors.passwordConfirmation}
                  />
                  <InputGroup.Text
                    onClick={() =>
                      passwordType2 === "password"
                        ? setPasswordType2("text")
                        : setPasswordType2("password")
                    }
                    style={{ cursor: "pointer" }}
                  >
                    {passwordType2 === "password" ? (
                      <i className="fa-regular fa-eye-slash"></i>
                    ) : (
                      <i className="fa-regular fa-eye"></i>
                    )}
                  </InputGroup.Text>
                </InputGroup>
                <ErrorMessage
                  component="span"
                  name="passwordConfirmation"
                  className="text-danger"
                />
              </Form.Group>
              {msg && <Alert variant={msgClass}>{msg}</Alert>}
              <div className="d-flex justify-content-center m-5">
                <Form.Check
                  required
                  name="terms"
                  label="Agree to terms and conditions"
                  onChange={handleChange}
                  feedback="You must agree before submitting."
                  feedbackType="invalid"
                />
              </div>
              <div className="d-flex justify-content-center m-5">
                <Button
                  className="borderRadius_15px"
                  variant="primary"
                  type="submit"
                >
                  S'inscrire
                </Button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
      <div className="d-flex div-border-wrapper">
        <div></div>
        <div>
          <span className="mx-5 ">ou</span>
        </div>
        <div></div>
      </div>
      <div className="d-flex justify-content-center pb-5">
        <Button
          className="borderRadius_15px"
          variant="primary"
          type="button"
          onClick={goToLogin}
        >
          Se connecter
        </Button>
      </div>
    </div>
  );
};

export default SignUp;
